import React from 'react';

import './FormFieldset.scss';

interface Props extends React.PropsWithChildren {
    disabled: boolean;
}

const FormFieldset: React.FC<Props> = ({ disabled, children }) => {
    return (
        <fieldset className="form-fieldset__container" disabled={disabled}>
            {children}
        </fieldset>
    );
};

export default FormFieldset;
